module.exports = __webpack_public_path__ + "static/media/icon_condition_focus_on_task.15e1adbb.svg";